import { render } from "./workpermitdetails.vue?vue&type=template&id=3d120d88&scoped=true"
import script from "./workpermitdetails.vue?vue&type=script&lang=js"
export * from "./workpermitdetails.vue?vue&type=script&lang=js"

import "./workpermitdetails.vue?vue&type=style&index=0&id=3d120d88&scoped=true&lang=css"
import "./workpermitdetails.vue?vue&type=style&index=1&id=3d120d88&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d120d88"]])

export default __exports__